module.exports = __webpack_public_path__ + "static/img/footerBackground.edf91fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/footerBackground.jpg
// module id = vn9U
// module chunks = 0